import type { Auth, Setting } from "types/shim";
import { useLocalStorage } from "@vueuse/core";

// 设置存储
export const systemStorage = useLocalStorage<Setting>("settings", {
  lang: "en",
  theme: "light",
  primaryColor: "#1890ff",
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  dateFormat: "YYYY-MM-DD",
});

// 用户认证存储
export const authStorage = useLocalStorage<Auth>("auth", {
  lastLoginType: "",
  lastUpgradePopupTime: null,
});
